import SimpleHeader from "../../NewApp/SimpleHeader";
import "./UntilYouSignTheLoan.css";
import BookBlock from "../../reusable/BookBlock/BookBlock";
import Footer from "../../Footer/Footer";

const UntilYouSignTheLoan: React.FC = () => (
  <div className="book-wrapper">
    <SimpleHeader onHome={() => window.location.href = '/'} onResources={() => window.location.href = '/resources'} />
    <div className="book-page-title">Մինչև վարկային պայմանագիրը կնքելը</div>
    <div className="book-page-description">Checklist</div>
    <div className="book-page-content">
        <BookBlock
        paragraphs={[
            'Վարկ վերցնելը հաճախ սկսվում է շատ պարզ հարցից․', 
            '«Ամսական քանի՞ դրամ եմ վճարելու»։', 
            'Բայց իրականում սա պատմության մի փոքր մասն է։', 
            'Վարկը միայն ամսական վճար չէ։ Այն որոշում է, թե առաջիկա ամիսներին կամ տարիներին Ձեր եկամտի որ մասն է «զբաղված» լինելու, ինչ նպատակներ կարող են հետաձգվել, և որքան ազատություն եք ունենալու անսպասելի իրավիճակների դեպքում։', 
            'Այս checklist-ը ֆինանսական կամ իրավաբանական խորհուրդ չէ։ Այն պարզապես գործիք է, որը կօգնի ավելի գիտակցված որոշում կայացնել և չստորագրել մի բան, որի արժեքը մինչև վերջ չեք հասկացել։', 
            `<a href="http://girlsandfinances.com/until_you_sign_the_loan.pdf" target="_blank" rel="noopener noreferrer">Ներբեռնել PDF տարբերակը</a>`]}
      />
    </div>
    <Footer></Footer>
  </div>
);

export default UntilYouSignTheLoan;